import _ from "lodash";
import { getAppConfig } from "config/client.config";
import axios from "axios";

export const ADD_DECK = "ADD_DECK";
export const RENAME_DECK = "RENAME_DECK";
export const EDIT_DECK = "EDIT_DECK";
export const DELETE_DECKS = "DELETE_DECKS";
export const MOVE_TO_FOLDER = "MOVE_TO_FOLDER";
export const MOVE_DECK = "MOVE_DECK";

const _addDeck = /* istanbul ignore next - redux passthrough function */ (
    status,
    data,
    err
) => {
    return { type: ADD_DECK, data, err, status };
};
const _renameDeck = /* istanbul ignore next - redux passthrough function */ (
    status,
    data,
    err
) => {
    return { type: RENAME_DECK, data, err, status };
};
const _updateDeck = /* istanbul ignore next - redux passthrough function */ (
    status,
    data,
    err
) => {
    return { type: EDIT_DECK, data, err, status };
};
const _deleteDecks = /* istanbul ignore next - redux passthrough function */ (
    status,
    data,
    err
) => {
    return { type: DELETE_DECKS, data, err, status };
};
const _moveToFolder = /* istanbul ignore next - redux passthrough function */ (
    status,
    data,
    err
) => {
    return { type: MOVE_TO_FOLDER, data, err, status };
};
const _moveDeck = /* istanbul ignore next - redux passthrough function */ (
    status,
    data,
    err
) => {
    return { type: MOVE_DECK, data, err, status };
};

/*
 * -----------------------------------------
 * Helper Functions for XLSX Parsing
 * -----------------------------------------
 */

const parseRow = (row, idx, readerType, shortId) => {
    let dataHash = {
        template: row.qtype,
        slide_id: row.id,
        slideSeq: idx,
        nav: { next: true, prev: false },
        data: {
            icon: row.icon ? row.icon : "icm icon-wall",
            title: row.title === undefined ? row.header : row.title,
            subtitle: row.qtype === "uploader" ? row.header : undefined,
            question: row.question,
            image: row.image,
            feedback:
                row.correct_feedback === undefined &&
                row.incorrect_feedback === undefined &&
                row.survey_feedback === undefined
                    ? null
                    : [
                          row.correct_feedback === undefined
                              ? "That is correct."
                              : row.correct_feedback,
                          row.incorrect_feedback === undefined
                              ? "That is incorrect."
                              : row.incorrect_feedback,
                          row.survey_feedback === undefined
                              ? "Thanks for your answer."
                              : row.survey_feedback,
                      ],
            purpose:
                readerType === "survey"
                    ? "Provide Insight"
                    : "Test Understanding",
        },
    };
    let options = _.filter(_.toPairs(row), (pair) => {
        return (
            pair[0].indexOf("Option") !== -1 ||
            pair[0].indexOf("option") !== -1 ||
            pair[0].indexOf("text") !== -1
        );
    });
    switch (row.qtype) {
        case "single_select":
            dataHash.data["options"] = _.map(
                _.filter(options, (option) => option[1] !== ""),
                (option, idx) => {
                    return {
                        text: option[1],
                        correct:
                            readerType !== "survey" &&
                            parseInt(row.correct, 0) === idx + 1
                                ? "checked"
                                : "",
                    };
                }
            );
            break;
        case "true_false":
            dataHash.data["choice"] = _.map(
                _.filter(options, (option) => option[1] !== ""),
                (option, idx) => {
                    return {
                        text: option[1],
                        correct:
                            readerType !== "survey" &&
                            parseInt(row.correct, 0) === idx + 1
                                ? "checked"
                                : "",
                    };
                }
            );
            break;
        case "multiple_select":
            dataHash.data["multiselect"] = _.map(options, (option, idx) => {
                return {
                    text: option[1],
                    correct:
                        readerType !== "survey" &&
                        row.correct.split(",").indexOf((idx + 1).toString()) !==
                            -1
                            ? "checked"
                            : "",
                };
            });
            break;
        case "pick_picture":
            dataHash.data["imageOpts"] = _.map(options, (option, idx) => {
                return {
                    image: option[1],
                    correct:
                        readerType !== "survey" &&
                        row.correct.split(",").indexOf((idx + 1).toString()) !==
                            -1
                            ? "checked"
                            : "",
                };
            });
            break;
        case "fill_in_the_blanks":
        case "textbox":
        default:
            dataHash.data["answer"] =
                readerType === "survey"
                    ? ""
                    : options[
                          parseInt(
                              /* istanbul ignore next - basic error catcher */
                              row.correct === undefined ? 1 : row.correct,
                              0
                          ) - 1
                      ][1];
    }
    return dataHash;
};

const buildDeck = (readerType, contentHash) => {
    let content = [];
    switch (readerType.toLowerCase()) {
        case "survey":
            _.each(contentHash, (row, idx) => {
                content.push(parseRow(row, idx, "survey", row.id));
            });
            break;
        default:
            _.each(contentHash, (row, idx) => {
                content.push(parseRow(row, idx, "assessment", row.id));
            });
    }
    return content;
};

/*
 * -----------------------------------------
 * end Helper Functions for XLSX Parsing
 * -----------------------------------------
 */

/*
 * -----------------------------------------
 * Base Function for Deck Save
 * -----------------------------------------
 */
const saveDeck = /* istanbul ignore next - redux passthrough function */ (
    name,
    topicId,
    content,
    size,
    deckId,
    readerType,
    points,
    coins
) => {
    return (dispatch, getState, Request) => {
        let reqBody =
            deckId === undefined
                ? {
                      name: name,
                      readerType: readerType,
                      course_id: getState().editingCourse._id,
                      topic_id: topicId,
                      sequence: _.find(getState().editingCourse.locations, {
                          _id: topicId,
                      }).contentList.length,
                      file_size: size,
                      points: points,
                      coins: coins,
                  }
                : {};
        let req = "";
        switch (readerType) {
            case "qdf":
            case "assessment":
            case "survey":
            case "game":
                if (content.name !== name) content.name = name;
                if (content.topic_id !== topicId) content.topic_id = topicId;
                reqBody = Object.assign({}, reqBody, content);
                req = JSON.stringify(reqBody);
                break;
            case "docdeck":
            case "videck":
            case "certdeck":
            case "badgedeck":
            case "rewarddeck":
            case "medaldeck":
                reqBody.content = content;
                req = JSON.stringify(reqBody);
                break;
            case "scormdeck":
                let formData = new FormData();
                formData.append("name", name);
                formData.append("readerType", readerType);
                formData.append("course_id", getState().editingCourse._id);
                formData.append("topic_id", topicId);
                formData.append(
                    "sequence",
                    _.find(getState().editingCourse.locations, {
                        _id: topicId,
                    }).contentList.length
                );
                formData.append("file_size", size);
                formData.append("upFiles", content);
                formData.append("points", points);
                formData.append("coins", coins);
                req = formData;
                break;
            default:
        }

        let saveDeckPath =
            deckId === undefined
                ? getAppConfig().endpoints.builderPaths["createDeckPath"]
                : getAppConfig().endpoints.builderPaths[
                      "updateDeckPath"
                  ].replace(":id", deckId);
        return Request.fetch(saveDeckPath, {
            method: "POST",
            body: req,
        })
            .then((resp) => {
                return resp.json();
            })
            .then((response) => {
                let dispatchArgs = {
                    topicId: topicId,
                    name: name,
                    size: size,
                    deckId: response._id,
                    readerType: readerType,
                };
                return Promise.resolve(
                    dispatch(
                        deckId === undefined
                            ? _addDeck(
                                  `Adding ${readerType}`,
                                  dispatchArgs,
                                  null
                              )
                            : _updateDeck(
                                  `Updating ${readerType}`,
                                  dispatchArgs,
                                  null
                              )
                    )
                );
            })
            .catch((err) => err);
    };
};
/* -----------------------------------------*/

/*
 * -----------------------------------------
 * Content Type Functions for Deck Create
 * -----------------------------------------
 */
const addPdf = /* istanbul ignore next - redux passthrough function */ (
    name,
    topicId,
    content,
    size,
    deckId,
    points,
    coins
) => {
    return saveDeck(
        name,
        topicId,
        content,
        size,
        deckId,
        "docdeck",
        points,
        coins
    );
};
const addVideo = /* istanbul ignore next - redux passthrough function */ (
    name,
    topicId,
    content,
    size,
    deckId,
    points,
    coins
) => {
    return saveDeck(
        name,
        topicId,
        content,
        size,
        deckId,
        "videck",
        points,
        coins
    );
};
const addCertDeck = /* istanbul ignore next - redux passthrough function */ (
    name,
    topicId,
    content,
    size,
    deckId,
    points,
    coins
) => {
    return saveDeck(
        name,
        topicId,
        content,
        size,
        deckId,
        "certdeck",
        points,
        coins
    );
};
const addScormDeck = /* istanbul ignore next - redux passthrough function */ (
    name,
    topicId,
    content,
    size,
    deckId,
    points,
    coins
) => {
    return saveDeck(
        name,
        topicId,
        content,
        size,
        deckId,
        "scormdeck",
        points,
        coins
    );
};
const addQDF = /* istanbul ignore next - redux passthrough function */ (
    name,
    topicId,
    content,
    size,
    deckId,
    points,
    coins
) => {
    return saveDeck(name, topicId, content, size, deckId, "qdf", points, coins);
};

const createDeck = /* istanbul ignore next - redux passthrough function */ (
    name,
    topicId,
    readerType,
    contentHash,
    size,
    passPercent,
    isFinal,
    qcount,
    selectedGame,
    deckId,
    points,
    coins,
    // viewCount,
    accessTime,
    images,
    colors
) => {
    let deckHash = buildDeck(readerType, contentHash);
    let sendJson = {
        qcount:
            parseInt(qcount, 0) === 0 || parseInt(qcount, 0) > deckHash.length
                ? deckHash.length
                : parseInt(qcount, 0),
        passingPercentage: passPercent === undefined ? 0 : passPercent,
        quo_game: selectedGame === undefined ? "" : selectedGame,
        isFinal: isFinal === undefined ? false : isFinal,
        points: points === undefined ? 0 : points,
        feedback_type: readerType === "survey" ? "no_feedback" : "overlay",
        // viewCount: viewCount === undefined ? 0 : viewCount,
        accessTime: accessTime === undefined ? "00:00:00" : accessTime,
        colors:
            colors === undefined
                ? {
                      base: "#ffffff",
                      baseText: "#212121",
                      primary: "#0097a7",
                      primaryText: "#fff",
                      primaryVariation: "#00838f",
                      secondary: "#454545",
                      secondaryText: "#ffffff",
                  }
                : colors,
        content: deckHash,
        images: images,
    };
    return saveDeck(
        name,
        topicId,
        sendJson,
        size,
        deckId,
        readerType,
        points,
        coins
    );
};
const renameDeck = /* istanbul ignore next - redux passthrough function */ (
    topicId,
    deckId,
    readerType,
    name
) => {
    return (dispatch, getState, Request) => {
        return Promise.resolve(
            dispatch(
                _renameDeck(
                    "renaming deck",
                    {
                        topicId: topicId,
                        deckId: deckId,
                        readerType: readerType,
                        name: name,
                    },
                    null
                )
            )
        ).then(() => {
            let deckRenamePath = getAppConfig().endpoints.builderPaths[
                "updateDeckPath"
            ].replace(":id", deckId);
            return Request.fetch(deckRenamePath, {
                method: "POST",
                body: JSON.stringify({
                    name: name,
                }),
            })
                .then((resp) => {
                    return resp.json();
                })
                .then((response) => {})
                .catch((err) => {
                    console.log(err);
                });
        });
    };
};
const deleteDecks = /* istanbul ignore next - redux passthrough function */ (
    topicId,
    decks
) => {
    return (dispatch, getState, Request) => {
        let deckDeletionPath;
        return Promise.all(
            _.map(decks, (deck) => {
                deckDeletionPath = getAppConfig()
                    .endpoints.builderPaths["deleteDeckPath"].replace(
                        ":id",
                        deck.id
                    )
                    .replace(
                        ":readerType",
                        (deck.readerType === "game"
                            ? "assessment"
                            : deck.readerType) + "s"
                    );
                return Request.fetch(deckDeletionPath, {
                    method: "POST",
                })
                    .then((resp) => {
                        return resp.json();
                    })
                    .then((response) => {
                        Promise.resolve(response);
                    })
                    .catch((err) => {
                        Promise.reject(err);
                    });
            })
        )
            .then((responses) => {
                Promise.resolve(
                    dispatch(
                        _deleteDecks(
                            "deleting decks",
                            {
                                topicId: topicId,
                                decks: _.map(decks, (deck) => {
                                    return {
                                        deckId: deck.id,
                                        readerType:
                                            deck.readerType === "deck"
                                                ? "qdf"
                                                : deck.readerType,
                                    };
                                }),
                            },
                            null
                        )
                    )
                );
            })
            .catch((err) => err.err);
    };
};
const moveToFolder = /* istanbul ignore next - redux passthrough function */ (
    topicId,
    decks,
    targetTopicId
) => {
    return (dispatch, getState, Request) => {
        let parentUpdatePath;
        return Promise.all(
            _.map(decks, (deck) => {
                parentUpdatePath = getAppConfig().endpoints.builderPaths[
                    "updateDeckPath"
                ].replace(":id", deck.id);
                return Request.fetch(parentUpdatePath, {
                    method: "POST",
                    body: JSON.stringify({
                        topic_id: targetTopicId,
                        course_id: getState().editingCourse._id,
                    }),
                })
                    .then((resp) => {
                        return resp.json();
                    })
                    .then((response) => {
                        Promise.resolve(response);
                    })
                    .catch((err) => {
                        Promise.reject(err);
                    });
            })
        )
            .then((responses) => {
                Promise.resolve(
                    dispatch(
                        _moveToFolder(
                            "moving decks to folder",
                            {
                                topicId: topicId,
                                targetTopicId: targetTopicId,
                                decks: _.map(decks, (deck) => {
                                    return {
                                        deckId: deck.id,
                                        readerType: deck.readerType,
                                    };
                                }),
                            },
                            null
                        )
                    )
                );
            })
            .catch((err) => err.err);
    };
};
const moveDeck = /* istanbul ignore next - redux passthrough function */ (
    topicId,
    deckId,
    readerType,
    direction
) => {
    return (dispatch, getState, Request) => {
        let reorderDecksPath = getAppConfig()
            .endpoints.builderPaths["reorderDecksPath"].replace(":id", deckId)
            .replace(":direction", direction);
        return Request.fetch(reorderDecksPath, {
            method: "POST",
        })
            .then((resp) => {
                return resp.json();
            })
            .then((response) => {
                dispatch(
                    _moveDeck(
                        `moving deck ${direction}`,
                        {
                            topicId: topicId,
                            deckId: deckId,
                            readerType: readerType,
                            direction: direction,
                        },
                        null
                    )
                );
            })
            .catch((err) => err);
    };
};
/*
 * -----------------------------------------
 * Base Function for Deck Save
 * -----------------------------------------
 */
const saveExamDecks = (topicId, decks) => {
    return (dispatch, getState, Request) => {
        let saveDeckPath = getAppConfig().endpoints.builderPaths[
            "createExamDeckPath"
        ];

        let reqBody = {
            decks: decks,
            course_id: getState().editingCourse._id,
            topic_id: topicId,
        };

        return Request.fetch(saveDeckPath, {
            method: "POST",
            body: JSON.stringify(reqBody),
        })
            .then((resp) => {
                return resp.json();
            })
            .then((response) => {
                for (let i = 0; i < response.length; i++) {
                    let deck = response[i];
                    let dispatchArgs = {
                        topicId: topicId,
                        name: deck.name,
                        size: deck.file_size,
                        deckId: deck._id,
                        readerType: deck.readerType,
                    };
                    Promise.resolve(
                        dispatch(
                            _addDeck(
                                `Adding ${deck.readerType}`,
                                dispatchArgs,
                                null
                            )
                        )
                    );
                }
                return response;
            })
            .catch((err) => console.log(err));
    };
};

const fetchList = (section) => {
    let signInPath =
        getAppConfig().apiUrls.gamifixURL +
        getAppConfig().endpoints.gamifixPaths.signInPath;
    let fetchListPath =
        getAppConfig().apiUrls.gamifixURL +
        getAppConfig().endpoints.gamifixPaths.fetchList.replace(
            ":section",
            section
        );
    return (dispatch, getState, Request) => {
        return axios({
            method: "POST",
            url: signInPath,
            data: {
                username: getAppConfig().gamifixCred.username,
                password: getAppConfig().gamifixCred.password,
            },
        })
            .then((response) => {
                let headers = {
                    "Content-Type": "application/json",
                    client: response.headers.client,
                    "access-token": response.headers["access-token"],
                    expiry: response.headers.expiry,
                    expires: response.headers.expires,
                    uid: response.headers.uid,
                    "token-type": "Bearer",
                };

                let options = {
                    method: "GET",
                    url: fetchListPath,
                    headers: headers,
                };

                return axios(options)
                    .then((response) => {
                        return response.data;
                    })
                    .then((data) => {
                        return Promise.resolve(data);
                    })
                    .catch((err) => {
                        return Promise.reject(err);
                    });
            })
            .then((data) => {
                return Promise.resolve(data);
            })
            .catch((err) => {
                return Promise.reject(err);
            });
    };
};

const addBadge = /* istanbul ignore next - redux passthrough function */ (
    name,
    topicId,
    content,
    size,
    deckId,
    points
) => {
    return saveDeck(
        name,
        topicId,
        content,
        size,
        deckId,
        "badgedeck",
        content.points,
        0
    );
};

const addMedal = /* istanbul ignore next - redux passthrough function */ (
    name,
    topicId,
    content,
    size,
    deckId
) => {
    return saveDeck(name, topicId, content, size, deckId, "medaldeck", 0);
};

const addReward = /* istanbul ignore next - redux passthrough function */ (
    name,
    topicId,
    content,
    size,
    deckId
) => {
    return saveDeck(name, topicId, content, size, deckId, "rewarddeck", 0);
};

class FileEditorAction {
    static addPdf = addPdf;
    static addQDF = addQDF;
    static addVideo = addVideo;
    static addCertDeck = addCertDeck;
    static addScormDeck = addScormDeck;
    static createDeck = createDeck;
    static renameDeck = renameDeck;
    static deleteDecks = deleteDecks;
    static moveToFolder = moveToFolder;
    static moveDeck = moveDeck;
    static saveExamDecks = saveExamDecks;
    static fetchList = fetchList;
    static addBadge = addBadge;
    static addMedal = addMedal;
    static addReward = addReward;
}

export default FileEditorAction;
